export default __webpack_public_path__ + "static/media/noir.f973455d.png";